// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dac0813f","455":"3973f7f9","977":"165a7e66"}[chunkId] + ".chunk.js";
};